var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarningCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_185",
    "data-name": "Group 185",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_124",
    "data-name": "Ellipse 124",
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#f79420"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1399",
    "data-name": "Path 1399",
    d: "M6.256-2.6a.584.584,0,0,1-.085.255.535.535,0,0,1-.248.191,1.873,1.873,0,0,1-.482.121,5.508,5.508,0,0,1-.745.043,5.475,5.475,0,0,1-.752-.043,1.862,1.862,0,0,1-.475-.121.535.535,0,0,1-.248-.191A.584.584,0,0,1,3.135-2.6L2.766-15.481a.622.622,0,0,1,.085-.326.618.618,0,0,1,.3-.234,2.232,2.232,0,0,1,.6-.135,8.635,8.635,0,0,1,.943-.043,7.241,7.241,0,0,1,.936.05,2.384,2.384,0,0,1,.589.142.687.687,0,0,1,.312.227.551.551,0,0,1,.092.319ZM6.7,1.554a4.408,4.408,0,0,1-.092.979,1.323,1.323,0,0,1-.326.638,1.337,1.337,0,0,1-.617.348,3.675,3.675,0,0,1-.965.106,3.758,3.758,0,0,1-.972-.106,1.291,1.291,0,0,1-.617-.348,1.358,1.358,0,0,1-.319-.638A4.408,4.408,0,0,1,2.7,1.554a4.586,4.586,0,0,1,.092-1A1.411,1.411,0,0,1,3.107-.1a1.262,1.262,0,0,1,.617-.355A3.758,3.758,0,0,1,4.7-.559a3.675,3.675,0,0,1,.965.106A1.307,1.307,0,0,1,6.277-.1,1.374,1.374,0,0,1,6.6.554,4.586,4.586,0,0,1,6.7,1.554Z",
    transform: "translate(12.805 23.797)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningCircle);
export default __webpack_public_path__ + "static/media/warning-circle.5d959b611665ea577618b45e01e688e5.svg";
export { ForwardRef as ReactComponent };